import { render, staticRenderFns } from "./Dashboard.yaml?vue&type=template&id=222afc7e&component"
import script from "./Dashboard.yaml?vue&type=script&lang=ts&component"
export * from "./Dashboard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports